import React, { useEffect } from "react";
import SlidePanel from "./SlidePanel";
import { timeAgo } from "../helpers/timeAgo";

const KINDS = {
  ship_approved: { icon: "✓", cls: "approved", head: "Your wreck was approved" },
  ship_rejected: { icon: "✕", cls: "rejected", head: "Your wreck wasn't approved" },
  edit_approved: { icon: "✓", cls: "approved", head: "Your edit was approved" },
  edit_rejected: { icon: "✕", cls: "rejected", head: "Your edit wasn't approved" },
  report_resolved: { icon: "✓", cls: "approved", head: "Your report was acted on" },
  report_dismissed: { icon: "✓", cls: "pending", head: "Your report was reviewed" },
};

export default function NotificationsPanel({ items, unread, ships, onMarkRead, onViewShip, onOpenSubmissions, onClose }) {
  // Whatever is on screen after a few seconds counts as seen (cleared on unmount, so quick closes don't).
  useEffect(() => {
    if (!unread) return undefined;
    const t = setTimeout(() => onMarkRead("all"), 4000);
    return () => clearTimeout(t);
  }, [unread, onMarkRead]);

  return (
    <SlidePanel
      title="Notifications"
      subtitle={unread ? `${unread} new` : "You're all caught up"}
      onClose={onClose}
      actions={unread > 0 && <button className="panel-icon-btn" onClick={() => onMarkRead("all")} title="Mark all as read" aria-label="Mark all as read">✓✓</button>}
    >
      {items.length === 0 && (
        <div className="panel-empty">
          <div className="panel-empty-icon">🔔</div>
          <p>No notifications yet.</p>
          <p className="panel-muted">When an admin approves or rejects something you submitted, or looks into a problem you reported, you'll see it here, including the reason if it was rejected.</p>
        </div>
      )}
      <div className="panel-list">
        {items.map((n) => {
          const k = KINDS[n.kind] || { icon: "•", cls: "pending", head: "Update" };
          const live = n.ship_id != null && ships.find((s) => Number(s.id) === Number(n.ship_id));
          const rejected = n.kind.endsWith("_rejected");
          const isReport = n.kind.startsWith("report_");
          return (
            <div key={n.id} className={`panel-item notif-item${n.read ? "" : " unread"}`}>
              <span className={`notif-icon status-badge ${k.cls}`} aria-hidden="true">{k.icon}</span>
              <div className="panel-item-main">
                <h3>{k.head}</h3>
                <p className="notif-title">{n.title || (n.ship_id ? `Wreck #${n.ship_id}` : "")}</p>
                {rejected && n.message && <p className="review-reason"><strong>Reason:</strong> {n.message}</p>}
                {isReport && n.message && <p className="notif-note">{n.message}</p>}
                <div className="panel-meta"><span>{timeAgo(n.ts)}</span></div>
                {rejected && <button className="panel-link" onClick={() => { onMarkRead([n.id]); onOpenSubmissions(); }}>See my submissions →</button>}
                {!rejected && live && <button className="panel-link" onClick={() => { onMarkRead([n.id]); onViewShip(live); }}>Show on map →</button>}
              </div>
            </div>
          );
        })}
      </div>
    </SlidePanel>
  );
}
